const tooltipStyles = (darkMode: "dark" | "light") => ({
  MuiTooltip: {
    styleOverrides: {
      popper: {
        zIndex: 9999,
      },
      tooltip: {
        backgroundColor: darkMode === "dark" ? "#1a1a1a" : "#f5f5f5", // Background color
        color: darkMode === "dark" ? "#ffffff" : "#000000", // Text color based on theme mode
        fontSize: "0.875rem", // Font size
        boxShadow:
          darkMode === "dark"
            ? "0px 4px 10px rgba(0, 0, 0, 0.5)"
            : "0px 4px 10px rgba(0, 0, 0, 0.1)", // Box shadow
        borderRadius: "8px", // Rounded corners
        padding: "8px 12px", // Padding
      },
      arrow: {
        color: darkMode === "dark" ? "#1a1a1a" : "#f5f5f5", // Arrow matches tooltip background
      },
    },
  },
});

export default tooltipStyles;
